import { Button } from '@/components/elements/forms/buttons';
import Icon from '@/components/icons/Icon';
import { SearchControlsManagerOutput } from '@/features/searchV2/modules/SearchControls/SearchControls.hooks';
import { classnames } from '@/helpers';
import { _t } from '@/locale';
import Filter from '../components/Filter/Filter';
import Sorting from '../components/Sorting/Sorting';

import { FilterManagerOutput } from '@/features/searchV2/components/Filter/Filter.types';
import { SortingManagerOutput } from '@/features/searchV2/components/Sorting/Sorting.types';
import { BaseSearchManagerOutput } from '@/hooks/search/useSearch.types';

export type DealSearchControlsProps = SearchControlsManagerOutput & {
  showSortingToggle?: boolean;
  showFilterToggle?: boolean;
  showMapToggle?: boolean;
  className?: string;
  searchManager: BaseSearchManagerOutput;
  filterManager: FilterManagerOutput;
  sortingManager: SortingManagerOutput;
  onToggleMap?: () => void;
};

const DealSearchControls = (props: DealSearchControlsProps) => {
  const { showMapToggle, onToggleMap, className } = props;

  return (
    <div className={classnames('flex items-center justify-between', className)}>
      <div className="gap-sm flex items-center">
        <Filter searchType={props.searchManager.type} {...props.filterManager} />
        <Sorting {...props.sortingManager} loading={props.isLoadingGeoLocation} />
        {showMapToggle && (
          <Button
            variant="primary"
            onClick={onToggleMap}
            rightIcon={
              <Icon variant="map" style={{ filter: 'var(--filter-color-fg-primary-inverse)', width: 16, height: 16 }} />
            }>
            <span>{_t('mapView')}</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default DealSearchControls;
